import flightsSuppliers from '../../flights/flights-suppliers';
import suppliers from '../../supplier/suppliers';
import {SIZE_MEDIUM} from '../../common/modal/modal-service';

export default function AtcFlightsService(
    $stateParams,
    timeFilter,
    atcTimeService,
    localStorageService,
    modalService,
    authService,
    atcApiService,
    l10nService,
) {
    'ngInject';

    const BOOK_MONTHS_ADVANCE = 11;
    const CHECK_RESULT_SEARCH_CONDITIONS = 'check-result-search-conditions';
    return {
        isCurrentDay,
        isLowCostAirline,
        isMultiSegmentFlight,
        isTwoSegmentFlight,
        decorateResponse,
        getFlightsCabinClasses,
        getFlightSupplierLogo,
        getFlightSupplierLogoSmall,
        getFlightAirlines,
        getMaxBookDate,
        initializeFlightsData,
        getCheckResultRequest,
        cleanCheckResultRequest,
        infoModal,
        confirmationModal,
        proccessResponse,
        prepareLocationData,
    };

    function isCurrentDay(date) {
        return atcTimeService
            .getDateInUserRegionFormat(date)
            .isSame(moment(), 'day');
    }

    function infoModal(header, message) {
        return modalService.createInfoModal(
            l10nService.localize(header),
            l10nService.localize(message),
            SIZE_MEDIUM
        );
    }

    function confirmationModal(header, message, callback) {
        return modalService.createConfirmationModal(
            l10nService.localize(header),
            l10nService.localize(message),
            SIZE_MEDIUM,
            callback
        );
    }

    function proccessResponse(data) {
        if (data.IsError) {
            // const modal = infoModal('Warning!', data.Message || ('Something went wrong. Please contact your travel advisor.'));
            const modal = infoModal(
                l10nService.localize('Warning!'),
                l10nService.localize(
                    'Sorry but your flights are not eligible to be changed online. Please contact your travel advisor.'
                )
            );
            modal();
        }
    }

    function getFlightsCabinClasses() {
        return atcApiService.getFlightsCabinClasses();
    }

    function getFlightAirlines(airlineList, allAirlineLabel, anyAirlineLabel) {
        if (airlineList.length === 1 && airlineList[0].Code === '$$') {
            return [{text: anyAirlineLabel, value: '00'}];
        }

        const list = airlineList.map((al) => {
            return {text: al.Name, value: al.Code};
        });

        list.unshift({text: allAirlineLabel, value: ''});

        return list;
    }

    function getFlightSupplierLogo(code) {
        return flightsSuppliers[code].logo || flightsSuppliers.unkwnown.logo;
    }

    function getFlightSupplierLogoSmall(code) {
        return (
            flightsSuppliers[code].logoSmall
            || flightsSuppliers.unkwnown.logoSmall
        );
    }

    function getMaxBookDate() {
        return moment().add({months: BOOK_MONTHS_ADVANCE});
    }

    function initializeFlightsData(apiFlights) {

        const flights = {};
        flights.SearchId = apiFlights.SearchId;
        flights.MoreResultsAvailable = apiFlights.MoreResultsAvailable;
        flights.Total = apiFlights.Total;
        flights.FilteredTotal = apiFlights.FilteredTotal;
        flights.IsAllRequestsSuccessful = true;
        flights.FareTypeLabels = [];
        flights.Recommendations = apiFlights.Recommendations;
        flights.FareComparisonMatrix = [];
        flights.Filters = {};

        return flights;
    }

    function getRequestFromStateParams() {
        return {
            pnr: $stateParams.pnr,
            trip: $stateParams.trip,
            department: $stateParams.department,
            fromTripDetails: $stateParams.fromTripDetails,
            isAgent: authService.isAuthorizedAgentUrl(),
        };
    }

    function setStateParamsFromRequest(req) {
        $stateParams.pnr = req.pnr;
        $stateParams.trip = req.trip;
        $stateParams.department = req.department;
        $stateParams.fromTripDetails = req.fromTripDetails;
        $stateParams.isAgent = req.isAgent;
    }

    function getCheckResultRequest() {
        let req = localStorageService.get(CHECK_RESULT_SEARCH_CONDITIONS);
        if (!req) {
            req = getRequestFromStateParams();
            localStorageService.set(CHECK_RESULT_SEARCH_CONDITIONS, req);
            return req;
        }

        if ($stateParams.pnr && $stateParams.pnr !== req.pnr) {
            req = getRequestFromStateParams();
        }
        setStateParamsFromRequest(req);
        return req;
    }

    function cleanCheckResultRequest() {
        localStorageService.set(CHECK_RESULT_SEARCH_CONDITIONS, null);
    }

    function decorateResponse(response) {
        attachAlternativesIfAny(response.data);
        convertTimeFormat(response.data);
        return response;
    }

    function attachAlternativesIfAny({Recommendations}) {
        _.each(Recommendations, (flight) => {
            let hasAlternatives = false;
            _.each(flight.FlightSegments, ({FlightGroups}) => {
                if (FlightGroups.length > 1) {
                    hasAlternatives = true;
                }
                _.each(FlightGroups, (group) => {
                    group.daysShift = getFlightGroupsDaysShift(group);
                });
            });
            flight.hasAlternatives = hasAlternatives;
        });
    }

    function convertTimeFormat(flights) {
        if (flights.Filters && flights.Filters.RecommendationSegmentsTimes) {

            //Change format of time according to regional settings
            _.each(flights.Filters.RecommendationSegmentsTimes, (segmentTimes) => {
                _.each(segmentTimes.ArrivalTimes, composeTimeValue);
                _.each(segmentTimes.DepartureTimes, composeTimeValue);
            });
        }

        function composeTimeValue(time) {
            const splitTimes = time.Key.split('-');
            time.Key = timeFilter(splitTimes[0]) + ' - ' + timeFilter(splitTimes[1]);
        }
    }

    function getFlightGroupsDaysShift(flightGroup) {
        const dDate = moment(flightGroup.Flights[0].DepartureDate, 'YYYY-MM-DD');
        const aDate = moment(flightGroup.Flights[flightGroup.Flights.length - 1].ArrivalDate, 'YYYY-MM-DD');
        let diff = aDate.diff(dDate, 'days');

        if (diff > 0) {
            diff = '+' + diff;
        } else if (diff < 0) {
            diff = '' + diff;
        }

        return diff;
    }

    function isLowCostAirline(flight) {
        return flight
            && flight.ServiceOption
            && flight.ServiceOption.Id !== suppliers.amadeus.serviceOptions.flights;
    }

    function isMultiSegmentFlight(flight) {
        return flight.FlightSegments.length > 2;
    }

    function isTwoSegmentFlight(flight) {
        return flight.FlightSegments.length === 2;
    }

    function prepareLocationData(location, allAirportsLabel) {
        const name = location.CityName + ', ' + location.CountryCode;
        const airport = location.Name ? location.Name : allAirportsLabel;
        const Code = location.Code;
        const DisplayString = name + ' - ' + airport + ' (' + location.Code + ')';

        return {
            name,
            airport,
            Code,
            DisplayString,
            IsCity: location.IsCity,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/services/atcFlightsService.js